import { render, staticRenderFns } from "./menuEdit.vue?vue&type=template&id=5362a725&"
import script from "./menuEdit.vue?vue&type=script&lang=js&"
export * from "./menuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports